// @flow

import styled from 'styled-components';
import { connect } from 'react-redux';

import type { HideWarningBarActionCreator } from '../../typings';
import ContentText from '../Text/ContentText';
import { hideWarningBar } from '../../../core/actions';
import UnstyledButton from '../ui/UnstyledButton';
import closeIcon from '../../../assets/svg/icons/close-gray.svg';

const Container = styled.div`
  background-color: ${props => props.theme.warningFullScreenBarColor};
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  width: 100%;
  height: 52px;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  transform: ${props => (props.isVisible ? 'translateY(0)' : 'translateY(-54px)')};
  transition: transform 1s ease;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const EmptySpacer = styled.div`
  height: 34px;
  width: 34px;
  background-color: transparent;
`;

const CloseButtonContainer = styled.div`
  display: flex;
  align-self: flex-end;
  height: 34px;
  width: 34px;
`;

type Props = {
  message: string,
  isVisible: boolean,
  hideWarningBar: HideWarningBarActionCreator
};

export function WarningFullScreenBarComponent({ message, isVisible, hideWarningBar }: Props) {
  return (
    <Container isVisible={isVisible}>
      <EmptySpacer />
      <TextContainer>
        <ContentText themeColor="whiteText" fontSize="14px" bold>
          {message}
        </ContentText>
      </TextContainer>
      <CloseButtonContainer>
        <UnstyledButton onClick={hideWarningBar}>
          <img src={closeIcon} alt="Close" />
        </UnstyledButton>
      </CloseButtonContainer>
    </Container>
  );
}

function mapStateToProps(state) {
  const { isVisible, message } = state.core.warningBar;
  return {
    message,
    isVisible
  };
}

export default connect(mapStateToProps, { hideWarningBar })(WarningFullScreenBarComponent);
